export default "__VITE_ASSET__Dhvanq$c__"